import React from "react";
import NavBar from "./NavBar";
import "../stylesheets/Thanks.css";
function Thanks() {
  return (
    <>
      <NavBar />
      <div className="thanks__container"></div>
    </>
  );
}

export default Thanks;
